import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LogService } from '../services/log-service';
import { PusherService } from '../services/pusher-service';

const isString = (item) => Object.prototype.toString.call(item) === '[object String]';

const eventNamesIsValid = (eventNames) => {
  if (isString(eventNames)) {
    return true;
  }
  if (Array.isArray(eventNames) && eventNames.every((eN) => isString(eN))) {
    return true;
  }

  return false;
};

const WebSocketRequest = ({ callApi, eventNames, buildOnMessage, selectRequestGuids }) => {
  if (!callApi) {
    LogService.logError(new Error('callApi is mandatory for web socket requests'));
    return;
  }

  if (!eventNames) {
    LogService.logError(new Error('eventNames is mandatory for web socket requests'));
    return;
  }

  if (!eventNamesIsValid(eventNames)) {
    LogService.logError(new Error('eventNames must either a string, or an array of strings'));
    return;
  }

  if (!buildOnMessage) {
    LogService.logError(new Error('buildOnMessage is mandatory for web socket requests'));
    return;
  }

  if (!selectRequestGuids) {
    LogService.logError(new Error('Parameter `selectRequestGuids` is mandatory for web socket requests'));
    return;
  }

  const messageHandler = PusherService.getMessageHandler();

  return callApi().pipe(
    mergeMap((data) => {
      return Observable.create((observer) => {
        const guids = selectRequestGuids(data) || [];
        const messages = [];
        let privateUnsub;
        const unsub = () => privateUnsub();

        const onMessage = buildOnMessage(observer, guids, messages, unsub);
        if (Array.isArray(eventNames)) {
          const unsubCollection = eventNames.map((eN) => messageHandler.subscribe(eN, onMessage));
          privateUnsub = () => unsubCollection.forEach((unsubscribe) => unsubscribe());
        } else {
          privateUnsub = messageHandler.subscribe(eventNames, onMessage);
        }
      });
    }),
  );
};

export default WebSocketRequest;
